import React from 'react'
import { BroadsheetHeadline } from '@/components/dashboard/broadsheet/BroadsheetHeadline'
import { BroadsheetKVList } from '@/components/dashboard/broadsheet/BroadsheetKVList'

/**
 * LoginEditorial
 *
 * Value-prop copy for the /login two-pane editorial pane.
 * Message: "Welcome back — track every dollar of AI spend."
 */
export function LoginEditorial(): React.ReactElement {
  return (
    <>
      <div>
        <p className="text-[11px] font-mono uppercase tracking-[0.15em] text-graphite">
          Verbal
        </p>
        <BroadsheetHeadline className="mt-2">
          Welcome back. Track every dollar of AI spend.
        </BroadsheetHeadline>
      </div>

      <BroadsheetKVList
        items={[
          { label: 'Unified spend dashboard', value: 'All providers in one view' },
          { label: 'Budget alerts', value: 'Set limits, stay on budget' },
          { label: 'Prompt coaching', value: '5-dimension quality scores' },
          { label: 'ROI tracking', value: 'Hours saved × hourly rate' },
        ]}
      />

      <p className="text-[11px] text-graphite leading-relaxed">
        Verbal connects to Claude, OpenAI, Gemini and more — giving you a single
        source of truth for every token your team spends.
      </p>
    </>
  )
}
